var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9926 2.66406H7.99759C7.29064 2.66406 6.61264 2.9449 6.11275 3.44479C5.61287 3.94467 5.33203 4.62267 5.33203 5.32962V26.6541C5.33203 27.361 5.61287 28.039 6.11275 28.5389C6.61264 29.0388 7.29064 29.3196 7.99759 29.3196H23.9909C24.6979 29.3196 25.3759 29.0388 25.8758 28.5389C26.3756 28.039 26.6565 27.361 26.6565 26.6541V9.32795L19.9926 2.66406Z",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6582 2.66406V7.99517C18.6582 8.70212 18.939 9.38012 19.4389 9.88001C19.9388 10.3799 20.6168 10.6607 21.3238 10.6607H26.6549",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3277 11.9961H10.6621",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3243 17.3242H10.6621",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3243 22.6562H10.6621",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.fde316965a3c9183a9594542266641fd.svg";
export { ForwardRef as ReactComponent };